module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-20-0720889f24bf2964b86fe1282bda8800.jpg";